import { useCallback, useMemo, useState } from 'react';

import { useDeletePlatformUserMutation, usePlatformUsersQuery } from '@dashboard/generated/wp/authentication';
import useCurrentPlatformId from '@dashboard/hooks/route/useCurrentPlatformId';

type DeleteUserProps = {
  platformUserId: string;
};
export default function useDeletePlatformUser() {
  const platformId = useCurrentPlatformId();
  const [deleteUser] = useDeletePlatformUserMutation();
  const { refetch } = usePlatformUsersQuery({ variables: { platformId } });
  const [loading, setLoading] = useState(false);

  const callback = useCallback(
    async ({ platformUserId }: DeleteUserProps) => {
      setLoading(true);
      try {
        const result = await deleteUser({ variables: { platformId, platformUserId } });
        await refetch();
        return result;
      } finally {
        setLoading(false);
      }
    },
    [deleteUser, platformId, refetch]
  );
  const state = useMemo(() => ({ loading }), [loading]);

  return [callback, state] as const;
}
